/* eslint-disable @typescript-eslint/no-explicit-any */
import { Stepper, Step, StepButton } from "@mui/material";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
// import withHeaderFooter from "@/app/csr-src/hocs/with-header-footer";
import withHeaderFooter, { IWithHeaderFooterProps } from "@/app/csr-src/hocs/with-header-footer";
import { addCartUtil } from "@/app/csr-src/utils/cartUtils";

import  CompetedIcon  from "@/app/csr-src/assets/icons/CompetedIcon.svg";

import Styles from "./index.module.scss";

const steps = ["My Cart", "Shipping & Payment", "Place order"];
type TransactionStepProps = IWithHeaderFooterProps & {
  children: any;
  step: number;
  refresh?: () => void;
  cartData?: any;
};
// TODO 立即购买是否需要cart第一步
const TransactionStep = observer(
  withHeaderFooter((props: TransactionStepProps) => {
    const [activeStep, setActiveStep] = useState(0);
    useEffect(() => {
      setActiveStep(props.step);
    }, [props.step]);

    useEffect(() => {
      initCartNum();
    }, [props.cartData]);

    const addCart = (data: any) => {
      if (data && data.length > 0) {
        addCartUtil(data).then(() => {
          // addCartUtil执行成功后，刷新列表数据
          // 去执行子组件的接口刷新
          if (props.refresh) {
            props.refresh();
          }
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        });
      }
    };

    const initCartNum = () => {
      props?.JDIHeader?.current?.initCartNum();
    };

    return (
      <div className={Styles.transactionStepPage}>
        <Stepper nonLinear activeStep={activeStep} className={Styles["step-item"]}>
          {steps.map((label, index) => {
            return (
              <Step key={label} disabled completed={index < activeStep}>
                <StepButton
                  color="inherit"
                  icon={
                    index < activeStep ? (
                      <CompetedIcon color="#CC0C1C" width={24} height={24} />
                    ) : undefined
                  }
                >
                  <div className={Styles["step-label"]}>{label}</div>
                </StepButton>
              </Step>
            );
          })}
        </Stepper>
        {props.children}
      </div>
    );
  }),
);

export default TransactionStep;
